var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "@horizon/base";
import { classMap } from "@horizon/base/directives";
import LoadingStyles from "./loading.css.js";
import { property } from "@horizon/base/decorators.js";
class HznLoading extends LitElement {
  constructor() {
    super(...arguments);
    this.tone = "brand";
    this.size = "small";
    this.label = "Loading";
  }
  render() {
    return html`<div role='status' aria-live='polite' aria-label=${this.label}>
      <svg
        role="progressbar"
        class="${classMap({
      "spinner": true,
      "is-tone-brand": this.tone === "brand",
      "is-tone-inverse": this.tone === "inverse",
      "is-on-brand": this.on === "brand",
      "is-on-brand-accent": this.on === "brand-accent",
      "is-small": this.size === "small",
      "is-medium": this.size === "medium",
      "is-large": this.size === "large"
    })}"
      >
        <circle class="spinner-indicator"></circle>
      </svg>
    </div>`;
  }
}
HznLoading.styles = [LoadingStyles];
__decorateClass([
  property({ type: String })
], HznLoading.prototype, "tone", 2);
__decorateClass([
  property({ type: String })
], HznLoading.prototype, "size", 2);
__decorateClass([
  property({ type: String })
], HznLoading.prototype, "on", 2);
__decorateClass([
  property({ type: String })
], HznLoading.prototype, "label", 2);
export {
  HznLoading
};
//# sourceMappingURL=loading.js.map
